import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { formatNumber } from '../../../utils/generalFunctions';

const ContinuarVenta = ({ venta, reestablecerVenta }) => {

    const dispatch =  useDispatch();

    const [continuarModal, setContinuarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Continuar venta */
    const handleProcesar = async () => {
        /* await setStatusProcesar(true);
        await dispatch(continuarVenta(venta));
        await handleCerrar();
        await setStatusProcesar(false); */
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerVenta(null);
            setContinuarModal(false);
        }
    }

    useEffect(() => {
        if(venta){
            setContinuarModal(true);
        }
    }, [venta]);

    return (
        <Modal show={continuarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Continuar venta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas continuar la venta hecha a "{venta?.cliente?.nombre ? venta?.cliente?.nombre + ' ' + venta?.cliente?.apellido : 'Público general'}" por un total de {formatNumber(venta?.total || 0, 2, '$ ', '')}?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <Link className="btn btn-success" to={`/ingresos/continuar/${venta?.id}`} disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</Link>
                    :
                        <Link className="btn btn-success" to={`/ingresos/continuar/${venta?.id}`}><i className="fas fa-check fa-sm"></i> Si</Link>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default ContinuarVenta;